import BaseCarousel from "./BaseCarousel";
import {translate} from "../../utils";
import Item from "./Item";
import GalleryItem from "./GalleryItem";

export default class GalleryCarousel extends BaseCarousel {
    constructor() {
        super();

        //this.hide();
    }

    init(textures) {
        for (let i = 0; i < textures.length; i++) {
            const item = new GalleryItem(textures[i]);
            this._itemHolder.addChild(item);
            this._items.push(item);
        }

        this._setItemPositions();
    }

    reveal() {
        this._nextButton.visible = true;
        this._prevButton.visible = true;
        this._selectButton.visible = true;
        this._interaction.interactive = true;
    }

    hide() {
        this._nextButton.visible = false;
        this._prevButton.visible = false;
        this._selectButton.visible = false;
        this._interaction.interactive = false;
    }

    _setItemPositions() {
        super._setItemPositions();
    }

    next() {
        if (this._animating || this._selectionMade)
            return;

        super.next();
    }

    prev() {
        if (this._animating || this._selectionMade)
            return;

        super.prev();
    }
}